module.exports = __webpack_public_path__ + "static/media/faq_(13).c6992b05.gif";